/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs */

const en__field_ichmchteberdennewsletterberangeboteinformiertwerden6 = /** @type {(inputs: _Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I would like to receive the newsletter from the Career Service of Goethe University and be regularly informed about recruiting events, job offers, workshop dates, and similar opportunities.`)
};

const de__field_ichmchteberdennewsletterberangeboteinformiertwerden6 = /** @type {(inputs: _Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich möchte den Newsletter des Career Service der Goethe-Universität erhalten und regelmäßig über Recruiting-Veranstaltungen, Stellenangebote, Workshoptermine etc. informiert werden.`)
};

/**
* | output |
* | --- |
* | "I would like to receive the newsletter from the Career Service of Goethe University and be regularly informed about recruiting events, job offers, workshop d..." |
*
* @param {_Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ichmchteberdennewsletterberangeboteinformiertwerden6 = /** @type {((inputs?: _Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ichmchteberdennewsletterberangeboteinformiertwerden6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ichmchteberdennewsletterberangeboteinformiertwerden6(inputs)
	return de__field_ichmchteberdennewsletterberangeboteinformiertwerden6(inputs)
});
export { _field_ichmchteberdennewsletterberangeboteinformiertwerden6 as "_field_ichMchteberDenNewsletterberAngeboteInformiertWerden" }